import React, { useContext, memo, useState, useEffect } from 'react'
import { FiSearch } from 'react-icons/fi'

import style from './Hero.module.scss'
import Link from '~components/Link'

import MicrocopyContext from '~contexts/MicrocopyContext'
import SearchContext from '~contexts/SearchContext'

const Hero = ({
  children
}) => {
  const microcopy = useContext(MicrocopyContext)
  const engine = useContext(SearchContext)

  let [show, setShow] = useState(false)
  useEffect(() => setShow(true), [])
  
  return (
    <>
      <section className={style.hero}>
        <div>
          { children }
        </div>
        <Link 
          to={ microcopy.text('headers.primary.buttons.signup.url') } 
          microcopy={ microcopy }
          className={style.button}
          data-type='signup'
        >
          { microcopy.text('headers.primary.buttons.signup.text') }
        </Link>
        <Link 
          to={ microcopy.text('headers.primary.buttons.console.url') } 
          microcopy={ microcopy }
          className={style.button}
          data-type='console'
        >
          { microcopy.text('headers.primary.buttons.console.text') }
        </Link>
      </section>
      <div className={style.searchWrapper}>
        <div 
          className={style.search} 
          data-show={show && engine.state.showSearchButton } 
          data-active={engine.state.showSearch}
          onClick={() => engine.show()}
        >
          <span>{ microcopy.text('search.prompt') }</span>
          <FiSearch />
        </div>
      </div>
    </>
  )
}

export default memo(Hero)
